import { render, staticRenderFns } from "./back-overseasreturnhandle.vue?vue&type=template&id=7fb6b159&scoped=true"
import script from "./back-overseasreturnhandle.vue?vue&type=script&lang=ts"
export * from "./back-overseasreturnhandle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb6b159",
  null
  
)

export default component.exports